import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Mount the React app to the DOM element with id "rankings-app"
document.addEventListener('DOMContentLoaded', () => {
    const appContainer = document.getElementById('trends-app');

    if (appContainer) {
        const root = createRoot(appContainer);
        root.render(<App />);
    } else {
        console.warn('Element with id "trends-app" not found');
    }
});
